<script>
import Component from './Detail'
export default Component
</script>
